import { ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, Eyebrow } from "@/components/Reveal";

const CONDITIONS = [
  "The refund request must be submitted within seven calendar days of the original transaction.",
  "The guarantee applies only to products or services specifically identified as guarantee-eligible at checkout.",
  "Work already completed, delivered, consumed, downloaded, licensed, or approved may be excluded from a full refund where permitted by applicable law and disclosed before purchase.",
  "Advertising spend, third-party software, domain registrations, hosting, platform charges, transaction fees, printing, purchased media, and other nonrecoverable third-party expenses are not refundable.",
  "Custom software, custom creative work, consulting already delivered, and projects that have entered substantial production may follow separate terms stated in the applicable proposal or agreement.",
];

export const Guarantee = () => (
  <section id="guarantee" className="relative py-24 sm:py-32">
    <div className="max-w-5xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div className="relative rounded-3xl border border-gold/30 bg-gradient-to-b from-obsidian-800 to-obsidian-900 p-8 sm:p-14 overflow-hidden gold-ring">
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-gold/10 blur-3xl pointer-events-none" />
          <div className="flex items-center justify-center w-16 h-16 rounded-2xl border border-gold/40 bg-obsidian mb-8">
            <ShieldCheck className="w-8 h-8 text-gold" />
          </div>
          <Eyebrow>Start With Confidence</Eyebrow>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mt-4">
            7-Day Money-Back Guarantee
          </h2>
          <p className="text-slate-400 mt-5 max-w-2xl leading-relaxed">
            If you purchase an eligible service or digital product and determine that it is not right
            for you, you may submit a refund request within 7 calendar days of the original purchase
            date, subject to the conditions below.
          </p>

          <div className="mt-9 space-y-3.5">
            {CONDITIONS.map((c) => (
              <div key={c} className="flex gap-3 text-sm text-slate-300 leading-relaxed">
                <span className="w-1.5 h-1.5 rounded-full bg-gold mt-2 shrink-0" />
                <span>{c}</span>
              </div>
            ))}
          </div>

          <p className="text-slate-500 text-sm mt-8 leading-relaxed">
            Always review the applicable service agreement, checkout terms, and refund conditions
            before purchasing. Nothing in this policy limits rights that cannot legally be waived
            under applicable consumer-protection law.
          </p>

          <Link
            to="/refund-policy"
            data-testid="guarantee-link-refund-policy"
            className="inline-block mt-8 rounded-full border border-gold/60 text-gold font-display font-bold px-7 py-3.5 hover:bg-gold hover:text-obsidian transition-colors duration-300"
          >
            View Complete Refund Policy
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Guarantee;
